import React, { useState } from 'react'
import tekne from '../assets/img/sonerusta4.jpeg'
import Swal from 'sweetalert2'
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios'

export const Tours = () => {

  const [name,setName] = useState();
  const [number,setNumber] = useState();
  const [guests,setGuests] = useState();
  const [message,setMessage] = useState();
  const [token,setToken] = useState();

  const changeHandler = (value) => {
    setToken(value)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
    if(token === undefined){
      Toast.fire({
        icon: 'error',
        title: `Lütfen captcha doğrulamasını geçiniz!`
      })
    }else if(message === undefined || message.length < 20) {
      Toast.fire({
        icon: 'error',
        title: `Mesajınız 20 karakterden kısa olamaz!`
      })
    }else if(number === undefined || number.length < 4){
      Toast.fire({
        icon: 'error',
        title: `Lütfen mail adresinizi girin!`
      })
    }
    else if(name === undefined){
      Toast.fire({
        icon: 'error',
        title: `Lütfen isminizi girin!`
      })
    }
    else if(guests === undefined){
      Toast.fire({
        icon: 'error',
        title: `Lütfen misafir sayısını girin!`
      })
    }
    else {
      
      const body = {"number" : number,"name" : name,"message" : message,"guests" : guests, "token" : token};
      const config = {
        headers: {
            'Access-Control-Allow-Origin': '*',
        }}
      const res = await axios.post("https://api.kuzeysoftware.com/mailer/gbt", body, config )
      if(res.data == "Mail başarıyla gönderildi."){
        Toast.fire({
          icon: 'success',
          title: `Mesajınız başarıyla gönderildi!`
        })
      }else{
        Toast.fire({
          icon: 'error',
          title: `Captcha doğrulamasını geçemediniz!`
        })
      }
    }
  }

  return (
    <section className="yacht-tours-container alternate-bg-two">
      <div className="auto-container">
        <div className="content-container">
          <div className="row clearfix">
            {/*Content Side*/}
            <div className="content-side col-lg-8 col-md-12 col-sm-12">
              <div className="content-inner">
                {/*Tour Details*/}
                <div className="tour-details">
                  <div className="info-title clearfix">
                    <div className="left-info">
                      <h1>Güvercinlik Günübirlik Balık Turları</h1>
                    </div>

                  </div>
                  <div className="main-image">
                    <img src="https://www.guvercinlikbalikturu.com/Guvercinlik-Koyu.jpg" alt="Güvercinlik Koyu" />
                  </div>
                  <div >
                  
                 
                  </div><br />
                  <div className="text-block">
                    <h4>Tur BİLGİSİ</h4>
                    <p>Kış ve yaz sezonları boyunca balık turları Güvercinlik limanından kalkan teknemiz tarafından yapılmaktadır. Mutlaka oltanız ve balık yemlerinizi yanınıza alınız! Turlarımız genelde sabah 05:00 ile akşam 16:00 saatleri arasında yapılmaktadır.  Özel turlar kafileler için yapılmakta olup önceden rezervasyon ve havanın durumuna bağlı olarak fiyat verebilmekteyiz.</p>
                  </div>
               
                </div>
              </div>
            </div>
            {/*Widgets Side*/}
            <div className="widgets-side col-lg-4 col-md-6 col-sm-12">
              <div className="widgets-content">
                {/*Widget*/}
                <div className="tour-widget single-booking-widget">
                  <div className="widget-inner">

                    <div className="default-form main-booking-form">
                      <form>
                        <h5>İletişim Formu</h5>
                        <div className="form-group">
                          <div className="field-inner">
                            <input onChange={(e) => setName(e.target.value)} type="text" name="name" placeholder="İsminiz" required />
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="field-inner">
                            <input onChange={(e) => setNumber(e.target.value)} type="text" name="number" placeholder="Telefon Numaranız" required />
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="field-inner">
                            <input onChange={(e) => setGuests(e.target.value)} type="number" name="guests" placeholder="Misafir Sayısı" required />
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="field-inner">
                            <input onChange={(e) => setMessage(e.target.value)} type="text" placeholder="Mesajınız" required />
                          </div>
                        </div>
                        <ReCAPTCHA sitekey='6LePGjMhAAAAANW1yUs6cabgyvv3MSmJ8_zi5pqh' onChange={changeHandler} /> <br/> 
                        <div className="form-group">
                          <button onClick={(e) => handleSubmit(e)} className="theme-btn"><span className="btn-title">Gönder</span></button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                {/*Widget*/}
                <div className="tour-widget advisor-widget">
                  <div className="widget-inner">
                    {/*Advisor Block*/}
                    <div className="advisor-block">
                      <div className="inner-box">

                        <div className="lower-box clearfix">
                          <div className="lower-content">
                            <h4><a href="#">İletişim Numarası</a></h4>
                            <div className="info"><a href="https://wa.me/05336809936"><span className="icon fa fa-whatsapp"></span></a><a href="tel:+905336809936"><span className="icon flaticon-assistance" />0533 680 99 36 </a></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*Widget*/}
                <div className="tour-widget reviews-widget">
                  <div className="widget-inner">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
